<template>
  <div class="bg-white">
    <Head>
      <Title>{{ $messages('services-mobile-top-ups.meta.title') }}</Title>
      <Meta name="description" hid="description" :content="$messages(`services-mobile-top-ups.meta.description`)" />
      <Meta name="og:image" hid="og:image" :content="ogImage" />
    </Head>

    <BlocksServiceHeroNew
      service="MobileTopUps"
      :hero="cmsData.hero[0]"
      :breadcrumbs="breadcrumbs"
      @scroll-to-checkout="scrollToMiniCheckout"
    />
    <BlocksContentBox
      v-bind="$messages('services-mobile-top-ups.unlimited_content_box')"
      header-bg-class="bg-bright-yellow"
    />
    <BlocksContentBox v-bind="$messages('services-mobile-top-ups.instant_content_box')">
      <template #visual>
        <BlocksContentBoxIconCanvasAsset
          :label="$messages('services-mobile-top-ups.instant_content_box.title')"
          service="topup"
          bg-class="bg-light-green"
        />
      </template>
    </BlocksContentBox>
    <BlocksUserReviewList />

    <BlocksFaqV2 v-bind="$messages('faq')" />

    <BlocksMiniCheckout ref="checkout" />
  </div>
</template>

<script>
import { optimize } from '@/utils/image-optimization'
import PageMixing from '@/mixins/page-mixin'
import { CMS_SERVICE_HERO_QUERY } from '@/utils/graphql-queries'

export default {

  mixins: [PageMixing('services-mobile-top-ups', 'Services - Mobile Top Ups', 'services-mobile-top-ups.meta.title')],
  async setup () {
    const locale = useLocale()
    const currentLocale = locale || 'en'
    const countryCookie = useCookie('mj.co.ct.n')
    const { $mRouter } = useNuxtApp()
    const countriesApi = useCountries()
    const datoHelperClient = useDatoHelper()

    const countryMtuSlugs = {
      CU: {
        en: 'recargas',
        es: 'recargas'
      },
      NG: {
        en: 'airtime',
        es: 'recargas'
      },
      MX: {
        en: 'recargas',
        es: 'recargas'
      },
      GH: {
        en: 'airtime',
        es: 'recargas'
      },
      KE: {
        en: 'airtime',
        es: 'recargas'
      },
      ET: {
        en: 'airtime',
        es: 'recargas'
      },
      CM: {
        en: 'airtime',
        es: 'recargas'
      }
    }
    const otherSlugs = {
      en: 'mobile-top-ups',
      es: 'recargas-moviles'
    }

    if (countryCookie.value) {
      const country = await countriesApi.getCountry(countryCookie.value)
      const mtuSlug = countryMtuSlugs[country.id][currentLocale] || otherSlugs[currentLocale]
      const route = $mRouter.getLocalRoute({ name: 'country-mtu', params: { country: country.slug, mtu: mtuSlug } })
      return navigateTo(route)
    }

    definePageMeta({
      key: 'mtu-home',
      middleware: ['country-redirect'],
      ref: 'mtu'
    })

    const query = `query MyQuery {
        genericMobileTopUp(locale: ${currentLocale}) {
            ${CMS_SERVICE_HERO_QUERY}
          }
        }`

    try {
      const data = await datoHelperClient.request(query, 'genericMobileTopUp' + currentLocale)
      if (!data || (!data.genericMobileTopUp)) {
        return createError({
          statusCode: 404
        })
      }
      const results = data
      return results
    } catch (ex) {
      useCustomError(ex)
    }
  },
  data () {
    return {
      breadcrumbs: [
        {
          title: this.$messages('label.home'),
          to: this.$mRouter.getLocalRoute({ name: 'index' })
        },
        {
          title: this.$messages('page_labels.mobile_top_ups')
        }
      ]
    }
  },
  computed: {
    ogImage () {
      return optimize(
        'https://majority.imgix.net/web-assets/meta/og.png',
        false,
        { w: 1200, h: 630, fit: 'fill', fill: 'solid', 'fill-color': '794DFF' }
      )
    },
    cmsData () {
      return this.genericMobileTopUp
    }
  },
  methods: {
    scrollToMiniCheckout () {
      this.$refs.checkout.$el.querySelector('#mini-checkout-form').scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }
}
</script>
